module.exports = __webpack_public_path__ + "img/parcel.7eb92af6.jpg";